<template>
  <div class="sub_cont">
    <div class="wrapper">
      <div class="box_locker_guide">
        <div class="left">
          <h2>보관함 가이드</h2>
          <ul class="guide_list">
            <li>등록전 <b>보관함 사이즈를 확인</b>하세요</li>
            <li>다중발송 시 <b>동일보관함에 적재가 가능</b>합니다.</li>
            <li>큰 물품은 <b>문서실에서 접수가 가능</b>합니다</li>
            <li>잔여보관함이 없을시 <b>문서실에서 접수</b>해주세요</li>
          </ul>
        </div>
        <div class="right">
          <h3 style="color:#fff">보관함 현황</h3>
           <div class="box_flex mgt5">
            <kendo-dropdownlist
                ref="facilityRef"
                :data-source="zone1DepthList"
                :data-text-field="'cdNm'"
                :data-value-field="'cdId'"
                :option-label="'사업장을 선택하세요.'"
                @change="lockerId=null; onChangeFacility();"
                class="w40"
            ></kendo-dropdownlist>
            <kendo-dropdownlist
                    ref="lockerIdRef"
                    :data-text-field="'lockerNm'"
                    :data-value-field="'lockerId'"
                    :option-label="'무인 보관함을 선택하세요.'"
                    v-model="lockerId"
                    class="w60"
            ></kendo-dropdownlist>
            <div class="small_btn w10 orange"  @click="openMapWindow">지도보기</div>
          </div>
           <div class="box_flex mgt10" style="flex-wrap:wrap">
          <div v-if="!!mailBox" class="box b4060">
            <span class="txt_guide txt_blue">등기함별도</span>
            <span class="txt_guide_size">{{ mailBox.cellWidth }}*{{ mailBox.cellHeight }}</span>
          </div>
          <div
              v-for="cell in cellList"
              :key="cell.cellId"
              :class="getCss(cell)">
            <span class="txt_guide txt_blue">[잔여{{ cell.avail }}]</span>
            <span class="txt_guide_size">{{ cell.cellWidth }}*{{ cell.cellHeight }}</span>
          </div>
           </div>
        </div>
      </div>
    </div>
    <locker-map-window
        ref="lockerMapWindowRef"
        :lockerId="lockerId"
    ></locker-map-window>
  </div>
</template>

<script>
import ApiUtil from "@/api/api.util";
import ApiConfig from "@/api/api.config";
import {ZoneMixin} from "@/mixin/Mixin";
import BlNoExcelUploadWindow from "@/components/blno/BlNoExcelUploadWindow.vue";
import LockerMapWindow from "@/components/mobile/LockerMapWindow.vue";

export default {
  name: "LockerGuide",
  components: {LockerMapWindow, BlNoExcelUploadWindow},
  mixins: [ZoneMixin],
  watch: {
    lockerId: {
      handler (val, oldVal) {
        this.callCellApi()
      }
    }
  },
  mounted() {
    const vm = this
    if (vm.zone1DepthList.length > 0) {
      if (process.env.NODE_ENV === 'production') {
        vm.$refs.facilityRef.kendoWidget().value(vm.zone1DepthList[2].cdId)
      } else {
        vm.$refs.facilityRef.kendoWidget().value(vm.zone1DepthList[1].cdId)
      }
    }
    vm.onChangeFacility()
  },
  methods: {
    callCellApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/cellList.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        lockerId: vm.lockerId
      }
      ApiUtil.post(url, param, {isShowLoadingBar: false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          return
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          vm.cellList = []
          vm.mailBox = null
          return
        }
        vm.cellList = response.data.resultData
        for(let i=0; i<vm.cellList.length; ++i){
          if(vm.cellList[i].mailBoxYn === 'Y'){
            vm.mailBox = vm.cellList[i]
            vm.cellList.splice(i,1)
            break
          }
        }
      })
    },
    getCss(cell){
      let css = cell.cellCss
      if(cell.avail === 0){
        css += ' zero'
      }
      return css
    },
    onChangeFacility () {
      const vm = this
      const facility = vm.$refs.facilityRef.kendoWidget().value()
      if(!!facility) {
        vm.facility = facility
        vm.callLockerNmList()
      }
    },
    callLockerNmList () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        facility: vm.facility,
        storageType: '01',
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerNmList.json`
      ApiUtil.post(url, param, {isShowLoadingBar: false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          return false
        }
        const lockerNmDataSource = response.data.resultData
        vm.$refs.lockerIdRef.kendoWidget().setDataSource(lockerNmDataSource)
        if (lockerNmDataSource.length > 0) {
          vm.lockerId = lockerNmDataSource[0].lockerId
          vm.$refs.lockerIdRef.kendoWidget().value(vm.lockerId)
        }
        vm.callCellApi()
      })
    },
    openMapWindow () {
      const vm = this
      console.log(vm.facility)
      vm.$refs.lockerMapWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
    },
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('ssoUserToken'),
      cellList: [],
      mailBox: null,
      lockerId: null,
    }
  },
}
</script>

<style scoped>
.box_flex>div, .box_flex>kendo, .box_flex>li{
  margin-right: inherit;
}
.box_flex{
  gap:10px;
}
</style>
